/* GW PDP rating row — Figma 30:10678 (155 x 28).

   The row is Judge.me's preview badge. Its stars are the design's stars, but
   the copy beside them is "5.0<star> from 2+ reviews", composed inside the app
   from settings the theme cannot reach, while the frame reads "5.0 (2)" in two
   type sizes. The numbers live on the badge's own data attributes
   (data-average-rating, data-number-of-reviews), so this rewrites the text from
   them rather than parsing the app's sentence: no app file is touched and the
   values stay whatever Judge.me last published.

   CSS alone cannot do it. attr() would yield "5.00" and there is no way to trim
   a decimal, split one text node into two type sizes, or drive the star fill
   from a score in a stylesheet.

   Judge.me renders the badge asynchronously and re-renders it on variant and
   review changes, so the observer stays for the life of the page.

   Styling lives in assets/section-gw-pdp.min.css; this file only writes the
   markup and the --gw-pdp-stars-fill percentage.
*/

const BADGE = '.jdgm-prev-badge';
const TEXT_CLASS = 'gw-pdp-rating__text';

function paint(badge) {
  const score = parseFloat(badge.getAttribute('data-average-rating'));
  const count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);

  /* No reviews: the stylesheet hides the badge on the same attribute, and
     writing nothing here keeps the two in step. */
  if (!Number.isFinite(score) || !Number.isFinite(count) || count < 1) return;

  let text = badge.querySelector('.' + TEXT_CLASS);

  if (!text) {
    text = document.createElement('span');
    text.className = TEXT_CLASS;
    text.setAttribute('aria-hidden', 'true');
    text.appendChild(document.createElement('span')).className = 'gw-pdp-rating__score';
    text.appendChild(document.createElement('span')).className = 'gw-pdp-rating__count';
    badge.appendChild(text);
  }

  /* aria-hidden above, because .jdgm-prev-badge__text is only visually hidden
     and still reads the full sentence to a screen reader. */
  const scoreText = score.toFixed(1);
  const countText = '(' + count + ')';

  if (text.firstChild.textContent !== scoreText) text.firstChild.textContent = scoreText;
  if (text.lastChild.textContent !== countText) text.lastChild.textContent = countText;

  const stars = badge.querySelector('.jdgm-prev-badge__stars');
  if (stars) {
    const fill = Math.max(0, Math.min(5, score)) / 5 * 100;
    stars.style.setProperty('--gw-pdp-stars-fill', fill + '%');
  }
}

function scan(root) {
  if (root.nodeType !== 1) return;
  if (root.matches && root.matches(BADGE)) paint(root);
  if (root.querySelectorAll) root.querySelectorAll(BADGE).forEach(paint);
}

scan(document.body);

new MutationObserver((records) => {
  for (const record of records) {
    if (record.type === 'attributes') {
      paint(record.target);
      continue;
    }
    record.addedNodes.forEach(scan);
  }
}).observe(document.body, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['data-average-rating', 'data-number-of-reviews'],
});
